import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, UsersRound } from "lucide-react";
import { AppDispatch, RootState } from "../../../../../store";
import { getInfinityCommissionDetails } from "../../../../../Redux/referral/slice";
import Pagenation from "../../../../../ecommerce/globalcomponents/pagenation/Pagenation";
import PrtCommDetailsTable from "./PrtCommDetailsTable";
import { formatEarningsCurrency } from "../../earningsAdapters";
import "../SamriddhiIncentives.css";

const PrtCommissonDetails = () => {
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const dateParam = queryParams.get("date") || "";

  const { infinityCommissionDetails } = useSelector(
    (state: RootState) => state.referral,
  );

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    if (dateParam) {
      let monthString = "";

      if (/^\d{6}$/.test(dateParam)) {
        monthString = dateParam;
      } else {
        const dateObj = new Date(dateParam);
        if (!isNaN(dateObj.getTime())) {
          const year = dateObj.getFullYear();
          const month = String(dateObj.getMonth() + 1).padStart(2, "0");
          monthString = `${year}${month}`;
        }
      }

      if (monthString) {
        dispatch(
          getInfinityCommissionDetails({
            month: monthString,
            page,
            limit,
            status: "ALL",
            sortOrder: "DESC",
          }),
        );
      }
    }
  }, [dispatch, dateParam, page, limit]);

  const summaryTotalNet = (infinityCommissionDetails.data || []).reduce(
    (sum, item) => sum + (item.netAmount || 0),
    0,
  );

  return (
    <section className="samriddhi-page">
      <div className="samriddhi-shell">
        <header className="samriddhi-page-header samriddhi-details-header">
          <div className="samriddhi-title-wrap">
            <button
              type="button"
              className="samriddhi-back-button"
              onClick={() => navigate("/PrtCommisson")}
              aria-label="Back to Samriddhi incentives"
            >
              <ArrowLeft size={20} />
            </button>
            <div>
              <span className="samriddhi-eyebrow">SAMRIDDHI DETAILS</span>
              <h1>Salar Samriddhi Incentives Details</h1>
              <p>
                Contributor purchases, commissions and net amounts for this
                period.
              </p>
            </div>
          </div>
          <div className="samriddhi-summary-pill">
            <span>Total Net</span>
            <strong>{formatEarningsCurrency(summaryTotalNet)}</strong>
          </div>
        </header>

        <div className="samriddhi-toolbar">
          <select
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setPage(1);
            }}
            aria-label="Entries per page"
          >
            {[10, 25, 50, 75, 100].map((val) => (
              <option value={val} key={val}>
                {val} Entries
              </option>
            ))}
          </select>
        </div>

        <PrtCommDetailsTable
          data={infinityCommissionDetails.data || []}
          loading={infinityCommissionDetails.loading}
        />

        <div className="samriddhi-mobile-list">
          {(infinityCommissionDetails.data || []).map((item, index) => (
            <article
              className="samriddhi-mobile-card samriddhi-mobile-detail-card"
              key={item._id || index}
            >
              <div className="samriddhi-mobile-card-top">
                <div>
                  <span className="samriddhi-mobile-label">CONTRIBUTOR</span>
                  <h2>{item.purchaserDetails?.name || item.purchaserName || "—"}</h2>
                  <small className="samriddhi-mobile-user-id">
                    {item.registerId || item.purchaserRegisterId || ""}
                  </small>
                </div>
                <span className="samriddhi-mobile-index">#{index + 1}</span>
              </div>
              <div className="samriddhi-mobile-detail-grid">
                <div>
                  <span>Order</span>
                  <strong>{item.orderNo}</strong>
                </div>
                <div>
                  <span>Purchase Amt</span>
                  <strong>
                    {formatEarningsCurrency(item.purchaseAmount)}
                  </strong>
                </div>
                <div>
                  <span>TDS</span>
                  <strong>
                    {formatEarningsCurrency(item.tdsAmount)}
                    {item.tdsIsEstimated ? " (est)" : ""}
                  </strong>
                </div>
                <div>
                  <span>Net Amount</span>
                  <strong className="samriddhi-mobile-amount">
                    {formatEarningsCurrency(item.netAmount)}
                  </strong>
                </div>
                <div>
                  <span>Status</span>
                  <strong>{item.status}</strong>
                </div>
              </div>
            </article>
          ))}
          {(!infinityCommissionDetails.data ||
            infinityCommissionDetails.data.length === 0) && (
            <div className="samriddhi-empty-state">
              <UsersRound size={30} />
              <strong>No contributor details found</strong>
              <span>No details found for this period.</span>
            </div>
          )}
        </div>

        <Pagenation
          currentPage={page}
          totalPages={
            infinityCommissionDetails.pagination?.totalPages || 0
          }
          onPageChange={setPage}
        />
      </div>
    </section>
  );
};

export default PrtCommissonDetails;
